import { createContext, useContext } from "react";

/**
 * Slot the {@link AppLayoutShell} reserves for a root page's top bar
 * (breadcrumbs + global actions). The slot spans the full content column —
 * including over the AI chat rail — so a page that portals its bar here gets
 * one horizontal row across the entire layout, with the chat panel starting
 * below it.
 */
export interface RootPageTopBarSlot {
  /** Portal target. `null` until the shell has mounted the slot. */
  node: HTMLElement | null;
  /** Live measured height of the slot, 0 while empty. */
  height: number;
}

export const RootPageTopBarContext = createContext<RootPageTopBarSlot | null>(
  null
);

/** `null` outside an {@link AppLayoutShell} (specs, storybook). */
export const useRootPageTopBarSlot = () => useContext(RootPageTopBarContext);
